import styled from 'styled-components';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Button from 'relements/build/esm/ui/button';
import Icon from 'relements/build/esm/ui/icon';

const containerStyle = ({ theme: { colors, space }, synced }) => ({
  padding: 2 * space.sm,
  background: synced ? colors.blue.pastel : colors.yellow.pastel,
  margin: `0 ${space.md}px`,
  border: `1px solid ${synced ? colors.blue.haptik : colors.yellow.haptik}`,
  borderRadius: space.xs,
});

export const Container = styled(Box)(containerStyle);

const descriptionStyle = ({ theme: { colors, space }, synced }) => ({
  margin: `0 ${space.md}px`,
  color: synced ? colors.blue.dark : colors.yellow.dark,
});
export const Description = styled(Text)(descriptionStyle);

const highlightedTextStyle = ({ theme: { colors }, synced }) => ({
  display: 'inline-block',
  color: synced ? colors.blue.dark : colors.yellow.dark,
});
export const HighlightedText = styled(Text)(highlightedTextStyle);

const resetButtonStyle = ({ theme: { space } }) => ({
  height: '30px',
  width: '55px',
  borderRadius: space.xs,
});
export const ResetButton = styled(Button)(resetButtonStyle);

const svgIconStyle = (props) => ({
  cursor: 'default',
});
export const SvgIcon = styled(Icon)(svgIconStyle);
